import * as React from 'react';
import { clsx } from 'clsx';
import { UIText1 } from '@cian/ui-kit';

import { DepartmentLink } from '../../DepartmentLink';
import { InsideIcon } from '../../InsideIcon';
import { RateMark } from '../parts';

import * as styles from './InfrastructureFromBuilder.css';

export interface IInfrastructureTerm {
  done: boolean;
  title: string;
}

export interface IInfrastructureFromBuilderProps {
  departmentLink: string;
  maxRate: string;
  onDepartmentLinkClick: () => void;
  rate: string;
  terms: IInfrastructureTerm[];
}

export const InfrastructureFromBuilder: React.FC<IInfrastructureFromBuilderProps> = ({
  departmentLink,
  maxRate,
  onDepartmentLinkClick,
  rate,
  terms,
}) => {
  return (
    <>
      <div className={styles['department-link-wrapper']}>
        <DepartmentLink href={departmentLink} onClick={onDepartmentLinkClick} size="large" />
      </div>
      <div className={styles['rate-mark-wrapper']}>
        <RateMark icon={<InsideIcon />} maxRate={maxRate} rate={rate} />
      </div>
      <ul className={styles['terms']} data-testid="InfrastructureFromBuilderTerms">
        {terms.map((term, idx) => (
          <li key={idx} className={clsx(styles['term-item'], term.done && styles['term-item--done'])}>
            <UIText1 color="current_color">{term.title}</UIText1>
          </li>
        ))}
      </ul>
    </>
  );
};
